import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Table from "../Table";
import UserTab from "../UserTab";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
import EliminarElemento from "../EliminarElemento";

function Activo(props) {
  const { history } = props;
  const [ActivoStateUpdate, setActivoStateUpdate] = useState([]);
  const [ActivoState, setActivoState] = useState([]);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [update, setUpdate] = useState(true);
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  // eslint-disable-next-line
  useEffect(() => {
    async function llamadaApi() {
      let response = await fetch(
        Parametros.urlApi + "asset_types?skip=0&limit=100&is_mantenedor=true",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
          },
        }
      );
      let responseJson = await response.json();

      if (response.status === 200) {
        let responseJsonUpdate = JSON.stringify(responseJson);
        let responseJsonstate = JSON.stringify(responseJson);
        setActivoState(JSON.parse(responseJsonUpdate));
        setActivoStateUpdate(JSON.parse(responseJsonstate));
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
    }
    llamadaApi();
  }, [update, history, usuario]);
  const [formularioState, setFormularioState] = useState({
    name: "",
  });
  const [editable, setEditable] = useState({
    id: "",
  });
  let handleStageForm = (event) => {
    setFormularioState({
      ...formularioState,
      [event.target.name]: event.target.value,
    });
  };
  let crearActivo = async (event) => {
    if (usuario.permisos.indexOf("Crear") > -1) {
      event.preventDefault();
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        let response = await fetch(Parametros.post + "asset_types/", {
          method: "POST",
          body: JSON.stringify(formularioState),
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: "Bearer " + usuario.key,
          },
        });

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setUpdate(!update);
          alert("ok");
          document.getElementById("formularioBusqueda").reset();
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.crear);
    }
  };

  let ActivoHandleChange = (index, e) => {
    const name = e.target.getAttribute("name");
    const value = e.currentTarget.value
      ? e.currentTarget.value
      : e.currentTarget.innerText;

    let newList = ActivoState;
    newList[index][name] = value;
    setActivoState(JSON.parse(JSON.stringify(newList)));

    let estadoUpdate = formularioUpdate;
    estadoUpdate[name] = value;

    setformularioUpdate(JSON.parse(JSON.stringify(estadoUpdate)));
  };

  let confirmarEdicion = async (item) => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      // setetapaStateUpdate(nuevoObjeto)
      if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
        let response = await fetch(
          Parametros.urlApi +
            "asset_types/" +
            parseInt(item.asset_type_id) +
            "?name=" +
            formularioUpdate.name,
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
          }
        );
        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          setEditable({});
          alert("ok");
          setUpdate(!update);
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setUpdate(!update);
          setEditable({});
        }
        document.getElementById("formularioBusqueda").reset();
      } else {
        // Do nothing!
        setEditable({});
        setUpdate(!update);
      }
    } else {
      alert(usuario.editar);
    }
  };

  let editar = (id) => {
    setActivoState(JSON.parse(JSON.stringify(ActivoStateUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };

  let cancelarEdicion = () => {
    setActivoState(JSON.parse(JSON.stringify(ActivoStateUpdate)));
    setEditable({});
  };
  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Tipos de activo"}></UserTab>
        <form
          id="formularioBusqueda"
          style={{ position: "relative" }}
          onSubmit={crearActivo}
        >
          <div className="col-md-4">
            <h5>Nombre Activo</h5>
            <input
              onChange={handleStageForm}
              name="name"
              required
              className="form-control"
            ></input>
          </div>
          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(ActivoState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={["Nombre Activo"]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table type={2} elementos={["Nombre Activo"]}></Table>
            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {ActivoState.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.asset_type_id}>
                      {editable === item.asset_type_id ? (
                        <>
                          <td>{item.asset_type_id}</td>
                          <td>
                            <input
                              value={item.name}
                              name="name"
                              onChange={(event) => {
                                ActivoHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <abbr title="Confirmar Edición">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion();
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.asset_type_id}</td>
                          <td>{item.name} </td>
                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.asset_type_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              ></span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`asset_types/${item.asset_type_id}`}
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(ActivoState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(Activo);
